import type { ModalStaticFunctions } from 'antd/es/modal/confirm'
import type { GlobalToken } from 'antd/es/theme/interface'

type ModalApi = Omit<ModalStaticFunctions, 'warn'>

interface DialogsBridge {
  modal: ModalApi
  token: GlobalToken
  styles: { dialog: string; dialogTitle: string }
  modalPrefixCls: string
}

let bridge: DialogsBridge | null = null

export const registerDialogsBridge = (value: DialogsBridge): void => {
  bridge = value
}

export const getDialogsBridge = (): DialogsBridge | null => bridge
